import React from "react"

// =============================================================================
// Props
// =============================================================================

export type NavigationHeaderProps = {
  /** Logo, branding, trigger, or any content to display in the header */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const headerStyles = "flex items-center justify-between mt-6 mb-2"

// =============================================================================
// Component
// =============================================================================

/**
 * The navigation header.
 *
 * Renders a container for the navigation header content.
 *
 * Compose with `Navigation.HeaderCollapsibleContent`, `Navigation.LogoLink`, and `Navigation.Trigger` to create a collapsible header with a trigger to expand/collapse the navigation.
 *
 * @example
 * <Navigation.Header>
 *   <Navigation.HeaderCollapsibleContent>
 *   <Navigation.LogoLink href="/dashboard" />
 *   </Navigation.HeaderCollapsibleContent>
 *
 *   <Navigation.Trigger />
 * </Navigation.Header>
 */
export function NavigationHeader({ children }: NavigationHeaderProps) {
  return (
    <div data-slot="navigation-header" className={headerStyles}>
      {children}
    </div>
  )
}

NavigationHeader.displayName = "Navigation.Header"
